const WAV_HEADER_BYTES = 44
const BYTES_PER_SAMPLE = 2

function writeAscii(view: DataView, offset: number, text: string): void {
  for (let position = 0; position < text.length; position++) {
    view.setUint8(offset + position, text.charCodeAt(position))
  }
}

/** Encodes mono float PCM (`-1..1`) as a 16-bit PCM WAV file. */
export function pcmToWav(samples: Float32Array, sampleRate: number): ArrayBuffer {
  const dataBytes = samples.length * BYTES_PER_SAMPLE
  const buffer = new ArrayBuffer(WAV_HEADER_BYTES + dataBytes)
  const view = new DataView(buffer)

  writeAscii(view, 0, 'RIFF')
  view.setUint32(4, 36 + dataBytes, true)
  writeAscii(view, 8, 'WAVE')
  writeAscii(view, 12, 'fmt ')
  view.setUint32(16, 16, true)
  view.setUint16(20, 1, true) // PCM
  view.setUint16(22, 1, true) // mono
  view.setUint32(24, sampleRate, true)
  view.setUint32(28, sampleRate * BYTES_PER_SAMPLE, true)
  view.setUint16(32, BYTES_PER_SAMPLE, true)
  view.setUint16(34, 16, true)
  writeAscii(view, 36, 'data')
  view.setUint32(40, dataBytes, true)

  for (let position = 0; position < samples.length; position++) {
    const clamped = Math.max(-1, Math.min(1, samples[position]))
    view.setInt16(
      WAV_HEADER_BYTES + position * BYTES_PER_SAMPLE,
      clamped < 0 ? clamped * 0x8000 : clamped * 0x7fff,
      true,
    )
  }
  return buffer
}

/** Duration in seconds of `sampleCount` samples at `sampleRate`. */
export function pcmDurationSeconds(sampleCount: number, sampleRate: number): number {
  return sampleRate > 0 ? sampleCount / sampleRate : 0
}

/** Half a second of silence as a `data:` URI — played synchronously inside
 * the user's click to unlock the shared `<audio>` element on iOS. */
export const SILENT_WAV_DATA_URI = ((): string => {
  const wavBytes = new Uint8Array(pcmToWav(new Float32Array(1024), 8000))
  let binary = ''
  for (const byte of wavBytes) binary += String.fromCharCode(byte)
  return `data:audio/wav;base64,${btoa(binary)}`
})()
